import angular from 'angular';

(function () {
    'use strict';

    angular.module('app.global_setting').config(routesConfig);

    routesConfig.$inject = ['$stateProvider'];

    /* @ngInject */
    function routesConfig($stateProvider) {
        $stateProvider
            .state('app.global_setting', {
                abstract: true,
                component: 'contentLayout',

            })
            .state('app.global_setting.list', {
                url: '/global-setting', views: {
                    content: {
                        component: 'globalSettingList',
                    },
                },
            })
    }
})();
